

export function handleSiteSteeringFieldChange(steeringPrefs) {
  const getPrefTypeById = (id) => {
    if (id == null) return null;
    const pref = steeringPrefs.find((p) => String(p.id) === String(id));
    return pref?.preference_type ?? null;
  };

  return function onFieldChange(name, value, current) {

    if (name === "active_steering_mode") {
      const changedType = getPrefTypeById(value);
      if (changedType && changedType !== "Idle") {
        return { preferred_steering_mode: value };
      }
      return null;
    }

    if (name === "preferred_steering_mode") {
      const currentActiveType = getPrefTypeById(current?.active_steering_mode);
      if (currentActiveType && currentActiveType !== "Idle") {
        return { active_steering_mode: value };
      }
      return null;
    }

    return null;
  };
}